/* eslint-disable complexity */
import { getAuthHeader, getCustomerId } from "./identityUtils";
import noticeError from "./notice-error";
import { requestHelper } from "./request-helper";

export async function getSubscriptionDetails() {
  const customerId = await getCustomerId();
  const authHeader = await getAuthHeader();
  if (!customerId || !authHeader) {
    return null;
  }
  const url = new URL(window.location.href);
  const xSiteOrigin =
    url.searchParams.get("x-site-origin") ||
    document.cookies?.["x-site-origin"];

  try {
    const response = await requestHelper.get({
      url: `/api/commerce/premier/v1/customers/${customerId}/subscriptions${
        xSiteOrigin ? `?x-site-origin=${xSiteOrigin}` : ""
      }`,
      headers: {
        Authorization: authHeader,
      },
    });

    if (response.status !== 200) {
      throw new Error("Failed to retrieve subscription details.");
    }

    return await response.data;
  } catch (error) {
    noticeError(error);
  }
}
